import { render } from "./UserPerformances.vue?vue&type=template&id=533b12b6"
import script from "./UserPerformances.vue?vue&type=script&lang=js"
export * from "./UserPerformances.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__